import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

/** "dark" = the page starts with a dark hero, so the transparent navbar renders light-on-dark. */
export type NavTone = 'light' | 'dark';

const NavToneContext = createContext<{
  tone: NavTone;
  setTone: (tone: NavTone) => void;
}>({ tone: 'light', setTone: () => {} });

export function NavToneProvider({ children }: { children: ReactNode }) {
  const [tone, setTone] = useState<NavTone>('light');
  return <NavToneContext.Provider value={{ tone, setTone }}>{children}</NavToneContext.Provider>;
}

export const useNavToneValue = () => useContext(NavToneContext).tone;

/** Pages with a dark hero call this; the navbar resets to light when they unmount. */
export function useNavTone(tone: NavTone) {
  const { setTone } = useContext(NavToneContext);
  useEffect(() => {
    setTone(tone);
    return () => setTone('light');
  }, [tone, setTone]);
}
